/**
 * Contagem regressiva para a partida (teste físico, item 25).
 *
 * A viagem não tem hora de partida: conta-se até a meia-noite do primeiro
 * dia, no fuso da viagem. Meses são de 30 dias — é uma contagem para olhar,
 * não um calendário; o que importa é ler "1 mês · 15 dias · 08 h · 24 min"
 * e não "45 dias".
 */
export interface Countdown {
  meses: number;
  dias: number;
  horas: number;
  minutos: number;
  /** `true` quando a partida já passou (ou é agora). */
  chegou: boolean;
}

export function countdownTo(instante: number, agora: number): Countdown {
  const restante = Math.max(0, instante - agora);
  if (restante === 0) return { meses: 0, dias: 0, horas: 0, minutos: 0, chegou: true };
  const minutosTotais = Math.floor(restante / 60_000);
  const minutos = minutosTotais % 60;
  const horasTotais = Math.floor(minutosTotais / 60);
  const horas = horasTotais % 24;
  const diasTotais = Math.floor(horasTotais / 24);
  return { meses: Math.floor(diasTotais / 30), dias: diasTotais % 30, horas, minutos, chegou: false };
}
